export default __webpack_public_path__ + "static/media/card-futuristic-quadratic.0a2917e6.svg";